import { request } from '@/common/services/request';

const filterInvitations = (data, params = {}) =>
  (data || []).filter((invitation) => {
    const organizationName =
      params.organization?.name || params.organization || params['organization.name'];
    if (organizationName && !invitation.organization?.name?.includes(organizationName)) {
      return false;
    }
    if (params.role && invitation.role !== params.role) {
      return false;
    }
    return true;
  });

export async function queryUserInvitations(params) {
  const result = await request('/api/tenant/user-invitations', {
    method: 'GET',
  });
  return {
    data: filterInvitations(result.data, params),
    success: true,
  };
}

export async function acceptInvitation(payload) {
  return request('/api/tenant/user-invitations/accept', {
    method: 'POST',
    data: {
      invitationId: payload.invitationId,
    },
  });
}

export async function rejectInvitation(payload) {
  return request('/api/tenant/user-invitations/reject', {
    method: 'POST',
    data: {
      invitationId: payload.invitationId,
    },
  });
}
